export class CustomerService {
    public idService: string;
    public serviceName: string;
    public note: string;
    public idCustomer: string;
}